import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DeviceStatusRoutingModule } from './device-status-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    DeviceStatusRoutingModule
  ]
})
export class DeviceStatusModule { }
